import { render, staticRenderFns } from "./judgeRuleSon.vue?vue&type=template&id=9bd65830&"
import script from "./judgeRuleSon.vue?vue&type=script&lang=js&"
export * from "./judgeRuleSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports